import { css } from "styled-components";
import { mix, rgba } from "polished";

const DefaultVariant = css`
  color: ${props => props.theme.colors.text.default};
  background-color: transparent;
  box-shadow: inset 0 0 0 2px ${props => props.theme.colors.bg.alt};
`;

const DefaultAltVariant = css`
  color: ${props => props.theme.colors.text.default};
  background-color: ${props => props.theme.colors.bg.alt};
`;

const PrimaryVariant = css`
  color: #fff;
  background-color: ${props => props.theme.colors.brand.blue};
`;

const PrimaryAltVariant = css`
  color: ${props => props.theme.colors.brand.blue};
  background-color: transparent;
  box-shadow: inset 0 0 0 2px ${props => props.theme.colors.brand.blue};
`;

const SecondaryVariant = css`
  color: #fff;
  background-color: ${props => props.theme.colors.brand.pink};
`;

const SecondaryAltVariant = css`
  color: ${props =>
    mix(0.5, props.theme.colors.text.default, props.theme.colors.brand.pink)};
  background-color: ${props => rgba(props.theme.colors.brand.pink, 0.25)};
`;

const FacebookVariant = css`
  color: #fff;
  background-color: #3b5998;
`;

const TwitterVariant = css`
  color: #fff;
  background-color: #1da1f2;
`;

const ButtonStyles = css`
  ${props => props.variant === "default" && DefaultVariant};
  ${props => props.variant === "defaultAlt" && DefaultAltVariant};
  ${props => props.variant === "primary" && PrimaryVariant};
  ${props => props.variant === "primaryAlt" && PrimaryAltVariant};
  ${props => props.variant === "secondary" && SecondaryVariant};
  ${props => props.variant === "secondaryAlt" && SecondaryAltVariant};
  ${props => props.variant === "facebook" && FacebookVariant};
  ${props => props.variant === "twitter" && TwitterVariant};
`;

export default ButtonStyles;
